import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const advancedFeatures = ['Todo el contenido del Megapack Completo', 'Módulo de Especialización: cómo elegir tu nicho y comunicarlo', 'Sistema de Autoridad Digital: 90 días para posicionarte como referente', 'Servicios Premium y Pricing de Lujo', 'Escalado sin más horas: 3 modelos para crecer', 'Sistemas de Captación Digital: SEO local, Meta Ads, email marketing', 'Hoja de Ruta del Primer Año: plan mes a mes'];
export function AdvancedEditionSection() {
  return <section className="py-28 px-6 bg-brand-purple text-brand-white" data-id="element-12">
      <div className="max-w-4xl mx-auto" data-id="element-13">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-14">
          <span className="inline-block bg-brand-gold/20 text-brand-gold font-bold tracking-widest text-sm uppercase px-4 py-1.5 rounded-full mb-6" data-id="element-15">
            PARA QUIENES QUIEREN IR MÁS LEJOS
          </span>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold mb-6 leading-tight" data-id="element-16">
            Edición Avanzada: De Consultorio a Marca
          </h2>
          <p className="text-lg md:text-xl font-sans text-brand-white/80 max-w-2xl mx-auto leading-relaxed" data-id="element-17">
            Para esteticistas que ya dominan lo básico y quieren dar el
            siguiente paso: especialización, autoridad digital, servicios
            premium y escalado del negocio.
          </p>
        </motion.div>

        <div className="bg-brand-white/5 rounded-3xl p-8 md:p-12 border border-brand-white/10 backdrop-blur-sm" data-id="element-18">
          <div className="space-y-5 mb-12" data-id="element-19">
            {advancedFeatures.map((feature, i) => <motion.div key={i} initial={{
            opacity: 0,
            x: -10
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: i * 0.1
          }} className="flex items-start gap-4" data-id="element-20">
                <CheckCircle2 className="w-6 h-6 text-brand-gold shrink-0 mt-0.5" data-id="element-21" />
                <span className="text-lg font-sans text-brand-white/90" data-id="element-22">
                  {feature}
                </span>
              </motion.div>)}
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.4
        }} className="text-center pt-8 border-t border-brand-white/10" data-id="element-23">
            <p className="text-xl text-brand-white/50 line-through mb-2" data-id="element-24">
              Valor total: $131.880
            </p>
            <p className="text-5xl md:text-6xl font-sans font-bold text-brand-gold mb-10" data-id="element-25">
              $27.990 ARS
            </p>

            <a href="https://gana-con-conocimiento.myshopify.com/cart/52148953874715:1" className="inline-block w-full md:w-auto px-10 py-5 bg-brand-white text-brand-purple text-lg font-bold rounded-full hover:bg-brand-cream transition-all duration-300 shadow-lg hover:shadow-brand-white/20 hover:-translate-y-1" data-id="element-26">
              Quiero la Edición Avanzada
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
}